import {
  doc,
  getDoc,
  onSnapshot,
  serverTimestamp,
  setDoc,
  Timestamp,
  collection,
} from "@firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { toast } from "react-toastify";
import * as clientFormConstants from '../constants/clientContactConstants';


import { db, functions, timeStamp } from "../../config/firebase";
import {
  acknowledgementEmailFormat,
  clientContactDetailsEmailFormat,
  removeHtmlTags,
} from "../../helpers/zivaHelpers";


export const contactScreenAction = (
  data,
  setLoading,
  id,
  workorder_id,
) => async (dispatch) => {
  try {
    let contactData = {
      name: data.name,
      email: data.email,
      phone_number: data.phonenumber,
      customer_id: id.toString(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      updatedBy: data.email,
    };

    let clientFormData = {
      message: removeHtmlTags(data.message),
      workorder_id: workorder_id.toString(),
      area: data.area,
      type_of_project: data.typeOfProject,
      place_type: data.place_type,
      status: "Prospect",
      customer_id: id.toString(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      updatedBy: data.email,
    };

    const getDataFromStatus = await getDoc(
      doc(db, "tbl_based_on_status", "Prospect")
    );

    const _statusDataToMerge = getDataFromStatus.data().cards;
    const cardData = [
      { id: workorder_id.toString(), workorder_id: workorder_id.toString() },
    ];
    let statusData = {
      cards: [...cardData, ..._statusDataToMerge],
      title: "Prospect",
      createdAt: serverTimestamp(),
    };

    const docRef = doc(db, "tbl_contact_form", id.toString());
    const clientDocRef = doc(db, "tbl_client_form", workorder_id.toString());
    const tableBasedOnStatusRef = doc(db, "tbl_based_on_status", "Prospect");

    await Promise.all([
      setDoc(docRef, contactData),
      sendEmail({ ...contactData, ...clientFormData }, setLoading,dispatch),
      setDoc(clientDocRef, clientFormData),
      setDoc(tableBasedOnStatusRef, statusData, { merge: true })
    ]);

  } catch (error) {
    console.log('error', error.message)
  }
};

const sendEmail = async (contactData, setLoading,dispatch) => {
  const sendEmailFirebaseFunction = httpsCallable(
    functions,
    "sendEmailHandler"
  );
  const { name, phone_number, message, email, workorder_id } = contactData;

  const AcknowledgeEmailHtml = acknowledgementEmailFormat(name);
  const SenderMailHtml = clientContactDetailsEmailFormat(
    name,
    message,
    email,
    phone_number,
    workorder_id
  );

  const acknowledgeEmailData = {
    from: "contactus@zivainteriors.com",
    to: email,
    subject: "ZivaInteriors: Acknowledgement",
    html: AcknowledgeEmailHtml,
  };

  const senderEmailData = {
    from: email,
    to: "contactus@zivainteriors.com",
    subject: "Subject: Interiors Works",
    html: SenderMailHtml,
  };

  try {
    await Promise.all([
      sendEmailFirebaseFunction(senderEmailData),
      sendEmailFirebaseFunction(acknowledgeEmailData)
    ]);
    toast.success("Your message has been sent successfully");
    dispatch({type: clientFormConstants.CLIENT_FORM_SUCCESS})
  } catch (error) {
    toast.error(error.data.message);
    dispatch({type: clientFormConstants.CLIENT_FORM_FAIL})
  } finally {
    setLoading(false);
  }
};


